useWorkingPatternsWarningsFactory.$inject = [];

export function useWorkingPatternsWarningsFactory() {

    return () => {

        const getWorkingPatternsWarnings = (maxWeeklyHours, userHoursMap) => {
            const userDailyHoursMap = Object.fromEntries(
                Object.entries(userHoursMap).map(([date, data]) => [date, data.period])
            );
            const numberOfScheduledDays = Object.values(userDailyHoursMap).length;
            const totalScheduledHours = Object.values(userDailyHoursMap).reduce((acc, curr) => (acc + curr), 0);
            const overAndBelowWarnings = getOverAndBelowWarnings(maxWeeklyHours, numberOfScheduledDays, totalScheduledHours);
            const wrongHoursOnSpecificDaysWarnings = getWrongHoursOnSpecificDaysWarnings(maxWeeklyHours, userDailyHoursMap);
            return {
                ...overAndBelowWarnings,
                daysWithWrongHours: wrongHoursOnSpecificDaysWarnings,
            };
        }

        const getOverAndBelowWarnings = (maxWeeklyHours, numberOfScheduledDays, totalScheduledHours) => {
            const daysCount = maxWeeklyHours?.working_pattern?.days_count ?? maxWeeklyHours?.working_pattern?.working_pattern_days.length;
            const overDays = daysCount < numberOfScheduledDays;
            const belowDays = daysCount > numberOfScheduledDays;
            const overHours = totalScheduledHours > maxWeeklyHours?.value;
            const belowHours = totalScheduledHours < maxWeeklyHours?.value;
            return {
                overDays: overDays,
                overHours: overHours,
                belowDays: belowDays,
                belowHours: belowHours,
                hoursDifference: Math.abs(maxWeeklyHours?.value - totalScheduledHours),
                daysDifference: Math.abs(daysCount - numberOfScheduledDays),
            }
        }

        const getWrongHoursOnSpecificDaysWarnings = (maxWeeklyHours, userDailyHoursMap) => {
            const workingPatternDays = maxWeeklyHours?.working_pattern?.working_pattern_days ?? [];
            if (workingPatternDays.length === 0) {
                return [];
            }

            let dayWithWrongHours = [];
            for (const date of Object.keys(userDailyHoursMap)) {
                const key = moment(date, 'MMMM DD, YYYY').format('ddd').toUpperCase();
                const workingPatternDay = workingPatternDays.find(day => day.day === key);
                if (workingPatternDay?.hours_count) {
                    const numberOfScheduledHours = userDailyHoursMap[date];
                    if (workingPatternDay.hours_count < numberOfScheduledHours) {
                        dayWithWrongHours.push({
                            ...workingPatternDay,
                            date: date,
                            hoursDifference: Math.abs(workingPatternDay.hours_count - numberOfScheduledHours),
                        });
                    }
                }
            }
            return dayWithWrongHours;
        }

        const isUserWorkingOnDayOffPattern = (maxWeeklyHours, shift) => {
            const workingPatternDays = maxWeeklyHours?.working_pattern?.working_pattern_days ?? [];
            if (workingPatternDays.length === 0) {
                return false;
            }
            return !workingPatternDays.find(day => day.day === moment(shift.day).format('ddd').toUpperCase());
        }

        return {
            getWorkingPatternsWarnings,
            isUserWorkingOnDayOffPattern
        }
    }
}